import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isInteger, toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-add-bonus-points',
  templateUrl: './add-bonus-points.component.html',
  styleUrls: ['./add-bonus-points.component.scss']
})
export class AddBonusPointsComponent implements OnInit {

  pointConversion = {
    points: 0 as number,
    imageTitle: ''
  };

  constructor(
    private modalService: NgbModal,
    private route: Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private excelService: ExportExcelService,
    private toastService: ToastClientService
  ) { }

  ngOnInit() {
  }

  // ========================================================
  // Variables
  // ========================================================
  showErrors = false;

  bonusSelection = {
    convert_points: true,
    egv: false,
    merchandise: false
  };

  egvTitle = '';
  merchTitle = '';
  egvType = '';
  egvImage: string | null = null;
  egvFile: File | null = null;
  merchImage: string | null = null;
  merchFile: File | null = null;
  convertPointsImage: string | null = null;
  convertTemplate: File | null = null;
  bannerImage: string | null = null;
  pointsImgTitle = '';
  rejecterdRecords: any = [];

  filteredDetails = {
    name: '',
    start_date: '',
    end_date: '',
    description: ''
  };



  // ========================================================
  // File Upload Functions
  // ========================================================
  uploadConvertPointsImage(e: Event): void {
    const input = e.target as HTMLInputElement;
    const file = input && input.files ? input.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => (this.convertPointsImage = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  uploadEGVImage(e: Event): void {
    const input = e.target as HTMLInputElement;
    const file = input && input.files ? input.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => (this.egvImage = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  uploadMerchImage(e: Event): void {
    const input = e.target as HTMLInputElement;
    const file = input && input.files ? input.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => (this.merchImage = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  uploadBannerImage(e: Event): void {
    const input = e.target as HTMLInputElement;
    const file = input && input.files ? input.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => (this.bannerImage = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  uploadTemplate(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input && input.files ? input.files[0] : null;

    if (!file) {
      this.toastService.Error('Please select a valid template file.');
      return;
    }

    // Assign file based on selected type(s)
    if (this.bonusSelection.convert_points) this.convertTemplate = file;
    if (this.bonusSelection.egv) this.egvFile = file;
    if (this.bonusSelection.merchandise) this.merchFile = file;

    this.toastService.Success('Template file uploaded successfully.');
  }

  // ========================================================
  // Toggle Logic
  // ========================================================
  clearEGVData() {
    this.egvFile = null;
    this.egvImage = null;
    this.egvTitle = '';
  }

  clearMerchandiseData() {
    this.merchFile = null;
    this.merchImage = null;
    this.merchTitle = '';
  }
  toggleSelectType: any = '';

  toggleEnableDisable(type: string): void {
    this.toggleSelectType = type
    console.log('Toggling type:', type);
    switch (type) {
      case 'convert_points':
        this.bonusSelection.convert_points = !this.bonusSelection.convert_points;
        break;
      case 'egv':
        this.bonusSelection.egv = !this.bonusSelection.egv;
        if (this.bonusSelection.egv) {
          this.bonusSelection.merchandise = false;
          this.clearMerchandiseData();
        }
        break;
      case 'merchandise':
        this.bonusSelection.merchandise = !this.bonusSelection.merchandise;
        if (this.bonusSelection.merchandise) {
          this.bonusSelection.egv = false;
          this.clearEGVData();
        }
        break;
    }
  }

  // ========================================================
  // Reset
  // ========================================================
  Reset() {
    // Reset common fields
    this.filteredDetails = { name: '', start_date: '', end_date: '', description: '' };

    // Reset bonus selection (set convert_points to true by default)
    this.bonusSelection = { convert_points: true, egv: false, merchandise: false };

    // Reset EGV fields
    this.egvTitle = '';
    this.egvImage = null;
    this.egvFile = null;

    // Reset Merchandise fields
    this.merchTitle = '';
    this.merchImage = null;
    this.merchFile = null;

    // Reset Convert Points fields
    this.pointConversion = { points: 0, imageTitle: '' };
    this.pointsImgTitle = '';
    this.convertPointsImage = null;
    this.convertTemplate = null;

    // Reset banner image
    this.bannerImage = null;

    // Reset file inputs by clearing them
    const fileInputs = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>;
    fileInputs.forEach(input => {
      input.value = '';
    });

    // Display toast notification
    this.toastService.Success('Form has been reset successfully.');
  }

  // ensureInteger() {
  //   this.pointConversion.points = Math.floor(Number(this.pointConversion.points) || 0);
  // }

  ensureInteger() {
    const cleaned = this.pointConversion.points.toString().replace(/[^0-9]/g, '');
    this.pointConversion.points = cleaned ? Number(cleaned) : 0;
  }

  // ========================================================
  // Sequential Validation (one toast at a time)
  // ========================================================
  validateFields(): boolean {
    //Template Download Validation  
    if (!this.bonusSelection.convert_points && !this.bonusSelection.egv && !this.bonusSelection.merchandise) {
      this.toastService.Error('Please select at least one bonus type.');
      return false;
    }
    // Common Fields
    if (!this.filteredDetails.name) {
      this.toastService.Error('Title/Scheme Name is required.');
      return false;
    }
    if (!this.filteredDetails.start_date) {
      this.toastService.Error('Start Date is required.');
      return false;
    }
    if (!this.filteredDetails.end_date) {
      this.toastService.Error('End Date is required.');
      return false;
    }
    if (!this.filteredDetails.description) {
      this.toastService.Error('Description is required.');
      return false;
    }
    if (!this.bannerImage) {
      this.toastService.Error('Banner Image is required.');
      return false;
    }

    // Convert Points Validation
    if (this.bonusSelection.convert_points) {
      if (!this.pointConversion.points) {
        this.toastService.Error('Points value is required for Convert Points.');
        return false;
      }
      if (!this.pointsImgTitle) {
        this.toastService.Error('Points Image Title is required for Convert Points.');
        return false;
      }
      if (!this.convertPointsImage) {
        this.toastService.Error('Conversion Image is required for Convert Points.');
        return false;
      }
      if (!this.convertTemplate) {
        this.toastService.Error('Please upload the common Template file for Convert Points.');
        return false;
      }
    }

    // EGV Validation
    if (this.bonusSelection.egv) {
      if (!this.egvTitle) {
        this.toastService.Error('EGV Title is required.');
        return false;
      }
      if (!this.egvImage) {
        this.toastService.Error('EGV Image is required.');
        return false;
      }
      if (!this.egvFile) {
        this.toastService.Error('Please upload the common Template file for EGV.');
        return false;
      }
    }

    // Merchandise Validation
    if (this.bonusSelection.merchandise) {
      if (!this.merchTitle) {
        this.toastService.Error('Merchandise Title is required.');
        return false;
      }
      if (!this.merchImage) {
        this.toastService.Error('Merchandise Image is required.');
        return false;
      }
      if (!this.merchFile) {
        this.toastService.Error('Please upload the common Template file for Merchandise.');
        return false;
      }
    }

    return true; // ✅ All good
  }

  // ========================================================
  // Submit
  // ========================================================
  submitBonusConfig() {
    if (!this.validateFields()) return;

    const formData = new FormData();
    formData.append('title', this.filteredDetails.name);
    formData.append('start_date', this.filteredDetails.start_date);
    formData.append('end_date', this.filteredDetails.end_date);
    formData.append('description', this.filteredDetails.description);
    formData.append('banner_img', this.bannerImage || '');
    formData.append('enable_convert_points', this.bonusSelection.convert_points ? '1' : '0');
    formData.append('enable_egv', this.bonusSelection.egv ? '1' : '0');
    formData.append('enable_merchandise', this.bonusSelection.merchandise ? '1' : '0');

    // Only one common upload template
    if (this.convertTemplate) formData.append('excel_data', this.convertTemplate);
    else if (this.egvFile) formData.append('excel_data', this.egvFile);
    else if (this.merchFile) formData.append('excel_data', this.merchFile);

    formData.append('convert_points', this.pointConversion.points.toString());
    formData.append('points_img_title', this.pointsImgTitle || '');
    formData.append('convert_points_img', this.convertPointsImage || '');
    formData.append('rewards_img', this.egvImage || this.merchImage || '');
    formData.append('rewards_img_title', this.egvTitle || this.merchTitle || '');

    this.apiService.upload1(this.apiConfig.createBonusPointsConfig, formData)
      .subscribe({
        next: (res: any) => {
          console.log('Bonus Points Config Creation Response:', res);

          if (res.status === 200) {
            console.log('Bonus Points Config Creation Response:', res.data);
            console.log('Bonus Points Config Creation Response:', res.body);
            this.rejecterdRecords = res.body.data.excel || [];
            if (res.body.data.success_status == 'Success') {
              this.toastService.Success('Bonus Points Configuration Created Successfully');
              this.route.navigateByUrl('/hubAdmin/bonus-points-config');
            }
            else {
              this.toastService.Error(res.body.data.message || 'Failed to create Bonus Points Configuration.');
              setTimeout(() => {
                document.getElementById('donloadRejectedRecords').click();
              }, 500);
            }
          }
        },
        error: (err) => {
          console.error(err);
          this.toastService.Error('Failed to create Bonus Points Configuration.');
        }
      });
  }

  // ========================================================
  // Template Download Logic
  // ========================================================
  downloadTemplateBasedOnSelection(): void {
    if (this.bonusSelection.convert_points && !this.bonusSelection.egv && !this.bonusSelection.merchandise) {
      const headers = ['Mobile Number'];
      this.excelService.egvTemplateHeaders(headers, 'Convert_Points_Template');
    } else if (this.bonusSelection.egv && !this.bonusSelection.merchandise) {
      const headers = ['Mobile Number', 'EGV Code'];
      this.excelService.egvTemplateHeaders(headers, 'EGV_Template');
    } else if (this.bonusSelection.merchandise) {
      const headers = ['Mobile Number'];
      this.excelService.egvTemplateHeaders(headers, 'Merchandise_Template');
    } else {
      this.toastService.Error('Please select a bonus type to download the correct template.');
    }
  }
}
